import { QueryClient } from '@tanstack/react-query'
import { isTerminalApiError } from '@omnea-app/legacy/utils/error-handling/isApiErrorOfType'
import { QUERY_TIME_CONFIG } from './queryConfig'

const TWENTY_MINUTES = 1000 * 60 * 20

export function createQueryClient(): QueryClient {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          // Don't retry client errors that won't resolve on retry
          if (isTerminalApiError(error)) return false

          // Retry up to 3 times otherwise (React Query default)
          return failureCount < 3
        },
        refetchOnWindowFocus: false, // default: true
        gcTime: QUERY_TIME_CONFIG.DEFAULT_GC_TIME,
        staleTime: QUERY_TIME_CONFIG.DEFAULT_STALE_TIME,
      },
    },
  })

  queryClient.setQueryDefaults(['coreDataItem'], {
    staleTime: TWENTY_MINUTES,
  })

  return queryClient
}
